import React, { useEffect, useState } from "react";

function Top3Trends({ data, team }) {
  const [trends, setTrends] = useState([]);
  const makeTrends = (d, selection) => {
    const mlWin = d.filter((obj) => obj.ml_win === true).length;
    const mlLoss = d.filter((obj) => obj.ml_loss === true).length;
    const sqMlWin = d.reduce((total, currentValue) => (total = total + Math.round(currentValue.sq_ml_win)), 0);
    const sqMlLoss = d.reduce((total, currentValue) => (total = total + Math.round(currentValue.sq_ml_loss)), 0);
    const atsRecordWin = d.filter((obj) => obj.cover_w === true).length;
    const atsRecordLoss = d.filter((obj) => obj.cover_l === true).length;
    const atsRecordPush = d.filter((obj) => obj.cover_push === true).length;
    const sqAtsRecordWin = d.filter((obj) => obj.sq_cover_w === true).length;
    const sqAtsRecordLoss = d.filter((obj) => obj.sq_cover_l === true).length;
    const sqAtsRecordPush = d.filter((obj) => obj.sq_cover_push === true).length;
    const overRecord = d.filter((obj) => obj.over === true).length;
    const underRecord = d.filter((obj) => obj.under === true).length;
    const pushRecord = d.filter((obj) => obj.ou_push === true).length;
    const sqOverRecord = d.filter((obj) => obj.sq_over === true).length;
    const sqUnderRecord = d.filter((obj) => obj.sq_under === true).length;
    const sqPushRecord = d.filter((obj) => obj.sq_ou_push === true).length;
    const atsValue = d.filter((obj) => obj.sq_cover_w === true).length - d.filter((obj) => obj.cover_w === true).length;
    const ouValue = d.filter((obj) => obj.sq_over === true).length - d.filter((obj) => obj.over === true).length;

    let trendsArray = [];
    if (selection === "all") {
      const winDiff = mlWin - sqMlWin;
      const ouDiff = overRecord - sqOverRecord;
      trendsArray = [
        {
          sentence: `In all games, ${team} based on SQ should be ${sqMlWin}-${sqMlLoss} ATS, but are actually ${mlWin}-${mlLoss}. Due for ${Math.abs(
            winDiff
          )} more ATS ${winDiff > 0 ? "wins" : "losses"}`,
          value: Math.abs(winDiff),
        },
        {
          sentence: `In all games, ${team} based on SQ should be ${sqOverRecord}-${sqUnderRecord}-${sqPushRecord} O/U, but are actually ${overRecord}-${underRecord}-${pushRecord}. Due for ${Math.abs(
            ouDiff
          )} ${ouDiff > 0 ? "more" : "less"} games ${ouDiff > 0 ? "under" : "over"}`,
          value: Math.abs(ouDiff),
        },
      ];
    }

    if (selection === "home") {
      const winDiff = mlWin - sqMlWin;
      const ouDiff = overRecord - sqOverRecord;
      trendsArray = [
        {
          sentence: `In home games, ${team} based on SQ should be ${sqMlWin}-${sqMlLoss} ATS, but are actually ${mlWin}-${mlLoss}. Due for ${Math.abs(
            winDiff
          )} more ATS ${winDiff > 0 ? "wins" : "losses"}`,
          value: Math.abs(winDiff),
        },
        {
          sentence: `In home games, ${team} based on SQ should be ${sqOverRecord}-${sqUnderRecord}-${sqPushRecord} O/U, but are actually ${overRecord}-${underRecord}-${pushRecord}. Due for ${Math.abs(
            ouDiff
          )} ${ouDiff > 0 ? "more" : "less"} games ${ouDiff > 0 ? "under" : "over"}`,
          value: Math.abs(ouDiff),
        },
      ];
    }

    if (selection === "away") {
      const winDiff = mlWin - sqMlWin;
      const ouDiff = overRecord - sqOverRecord;
      trendsArray = [
        {
          sentence: `In away games, ${team} based on SQ should be ${sqMlWin}-${sqMlLoss} ATS, but are actually ${mlWin}-${mlLoss}. Due for ${Math.abs(
            winDiff
          )} more ATS ${winDiff > 0 ? "wins" : "losses"}`,
          value: Math.abs(winDiff),
        },
        {
          sentence: `In away games, ${team} based on SQ should be ${sqOverRecord}-${sqUnderRecord}-${sqPushRecord} O/U, but are actually ${overRecord}-${underRecord}-${pushRecord}. Due for ${Math.abs(
            ouDiff
          )} ${ouDiff > 0 ? "more" : "less"} games ${ouDiff > 0 ? "under" : "over"}`,
          value: Math.abs(ouDiff),
        },
      ];
    }
    if (selection === "favorite") {
      const winDiff = mlWin - sqMlWin;
      const ouDiff = overRecord - sqOverRecord;
      trendsArray = [
        {
          sentence: `As a favorite, ${team} based on SQ should be ${sqMlWin}-${sqMlLoss} ATS, but are actually ${mlWin}-${mlLoss}. Due for ${Math.abs(
            winDiff
          )} more ATS ${winDiff > 0 ? "wins" : "losses"}`,
          value: Math.abs(winDiff),
        },
        {
          sentence: `As a favorite, ${team} based on SQ should be ${sqOverRecord}-${sqUnderRecord}-${sqPushRecord} O/U, but are actually ${overRecord}-${underRecord}-${pushRecord}. Due for ${Math.abs(
            ouDiff
          )} ${ouDiff > 0 ? "more" : "less"} games ${ouDiff > 0 ? "under" : "over"}`,
          value: Math.abs(ouDiff),
        },
      ];
    }
    if (selection === "underdog") {
      const winDiff = mlWin - sqMlWin;
      const ouDiff = overRecord - sqOverRecord;
      trendsArray = [
        {
          sentence: `As a uderdog, ${team} based on SQ should be ${sqMlWin}-${sqMlLoss} ATS, but are actually ${mlWin}-${mlLoss}. Due for ${Math.abs(
            winDiff
          )} more ATS ${winDiff > 0 ? "wins" : "losses"}`,
          value: Math.abs(winDiff),
        },
        {
          sentence: `As a favorite, ${team} based on SQ should be ${sqOverRecord}-${sqUnderRecord}-${sqPushRecord} O/U, but are actually ${overRecord}-${underRecord}-${pushRecord}. Due for ${Math.abs(
            ouDiff
          )} ${ouDiff > 0 ? "more" : "less"} games ${ouDiff > 0 ? "under" : "over"}`,
          value: Math.abs(ouDiff),
        },
      ];
    }
    return trendsArray;
  };

  useEffect(() => {
    let sentences = makeTrends(data, "all");
    sentences = sentences.concat(
      makeTrends(
        data.filter((it) => it.location == "home"),
        "home"
      )
    );
    sentences = sentences.concat(
      makeTrends(
        data.filter((it) => it.location == "away"),
        "away"
      )
    );
    sentences = sentences.concat(
      makeTrends(
        data.filter((it) => it.closing_spread >= -80 && it.closing_spread <= 0),
        "favorite"
      )
    );
    sentences = sentences.concat(
      makeTrends(
        data.filter((it) => it.closing_spread >= 0 && it.closing_spread <= 80),
        "underdog"
      )
    );

    sentences.sort((a, b) => b.value - a.value);
    console.log(sentences);
    sentences = sentences.slice(0, 3);
    setTrends(sentences);
  }, [data]);

  return (
    <div className="row mb-5">
      <div className="col-12 text-center mb-3">
        <h2>Top 3 Trends {team}</h2>
      </div>
      {trends.map((trend, index) => {
        return (
          <div key={index} className="col-md-4 col-sm-12 mb-2">
            <div className="card box-shadow-1 b-radius-2">
              <div className="card-body">
                <p className="card-text text-black text-center fw-7">{trend.sentence} </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Top3Trends;
